import type { HTMLAttributes } from 'react';
import { Fragment } from 'react';

import type { BreadcrumbData } from 'use-react-router-breadcrumbs';

import { BreadcrumbItem } from './BreadcrumbItem';

export interface BreadcrumbProps {
    breadcrumbs: BreadcrumbData[];
    breadcrumbHiddenItems?: RegExp[];
    separator?: string;
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLElement>;
}

export const Breadcrumb = ({
    breadcrumbs,
    breadcrumbHiddenItems = [],
    separator = '/',
    dataTestid,
    htmlAttributes,
}: BreadcrumbProps) => {
    const visibleBreadcrumbs = breadcrumbs.filter(
        ({ key }) => !breadcrumbHiddenItems.some((breadcrumbHiddenItem) => new RegExp(breadcrumbHiddenItem).test(key))
    );

    return (
        <ol
            id='breadcrumb'
            className='flex flex-row items-center'
            data-testid={dataTestid}
            data-component-name='Breadcrumb'
            {...htmlAttributes}
        >
            {visibleBreadcrumbs.map(({ key, match, breadcrumb, location }, idx) => {
                const isFirst = idx === 0;
                const isActive = !!`${match.pathname}/`.match(location.pathname);

                return (
                    <Fragment key={key}>
                        <BreadcrumbItem
                            href={match.pathname}
                            state={isFirst ? 'first' : isActive ? 'active' : 'default'}
                            dataTestid='breadcrumb-item'
                        >
                            {breadcrumb}
                        </BreadcrumbItem>
                        {idx !== visibleBreadcrumbs.length - 1 && (
                            <li className='text-sm text-gray-600'>{separator}</li>
                        )}
                    </Fragment>
                );
            })}
        </ol>
    );
};
